import * as React from 'react';
import s from './singleTag.scss';
import {Link} from 'react-router-dom';
import {logger} from '../../../utils/bi';

export type SingleTagProps = {
  label: {
    name: string;
    path: string;
  };
};
class SingleTag extends React.Component<SingleTagProps, {}> {
  render() {
    const {label} = this.props;
    const {path, name} = label;
    return (
      <li>
        <Link
          data-hooks="single-tag"
          to={path}
          className={s.tag}
          onClick={() => {
            logger({
              evid: 334,
              button_name: name.toLowerCase(),
              location: 'article'
            });
          }}
        >
          {name}
        </Link>
      </li>
    );
  }
}
export default SingleTag;
